import "antd/dist/antd.less";
import "assets/styles/base.less";
import "assets/styles/globals.less";
import React from "react";
import { useRouter } from "next/router";
import Script from "next/script";
import Head from "next/head";
import { IntlProvider, useIntl } from "react-intl";
import { ConfigProvider } from "antd";
import { AppContext, AppProvider } from "contexts/app";
// import SEO from "components/Seo";
import getLocale from "locales";
import axios from "utils/axios";
import cookie from "utils/cookie";
import { getHosts } from "utils/method";
import { message } from "antd";
const Package = require("../../package.json");

const Content = ({ children }) => {
  const [appState, appDispatch] = React.useContext(AppContext);
  React.useEffect(() => {
    const theme = cookie.get("theme");
    const isDark = theme != "light";
    appDispatch({ payload: { isDark } });
  }, []);

  React.useEffect(() => {
    const { host } = getHosts();
    const hostTopDomain = host.split(".").slice(-2).join("."); //smnvbtp.cn
    const envTopDomain = process.env.NEXT_PUBLIC_host.split(".")
      .slice(-2)
      .join("."); //xt.com
    if (hostTopDomain === envTopDomain) return;
    const aList = document.getElementsByTagName("a");
    for (let i = 0; i < aList.length; i++) {
      const aHost = aList[i].host;
      const aHostTopDomain = aHost.split(".").slice(-2).join(".");
      if (aHostTopDomain === envTopDomain && aHostTopDomain !== hostTopDomain) {
        aList[i].href = aList[i].href.replace(aHostTopDomain, hostTopDomain);
      }
    }
  }, []);

  return children;
};

function MyApp({ Component, pageProps }) {
  const { locale, locales, defaultLocale } = useRouter();
  const localeObj = getLocale(locale);
  // console.log("app useRouter", { locale, locales, defaultLocale });
  axios.instance.defaults.headers.lang = localeObj.key;
  const payload = {
    lang: localeObj.key,
    // isDark: (pageProps.COOKIES || {}).theme !== "light",
  };
  React.useEffect(() => {
    let clientCode = cookie.get("clientCode");
    if (!clientCode || clientCode.length !== 32) {
      clientCode = Date.now() + generateNonceStr(19);
      cookie.set("clientCode", clientCode);
    }
    axios.instance.defaults.headers["client-code"] = clientCode;
    message.config({
      top: 60,
    });
    const htmlDom = document.querySelector("html");
    htmlDom && htmlDom.setAttribute("translate", "no");
  }, []);
  console.log(process.env.projectGroup);

  const domain =
    process.env.NODE_ENV !== "production"
      ? ""
      : process.env.NEXT_PUBLIC_cdn + "/public";

  return (
    <IntlProvider locale={localeObj.name} messages={localeObj.message}>
      <ConfigProvider locale={localeObj.antd} autoInsertSpaceInButton={false}>
        {/*<SEO tdk={pageProps.TDK || {}} resolvedUrl={pageProps.resolvedUrl} />*/}
        <Head>
          <meta name="version" content={`${Package.version}`} key="version" />
          <meta
            key="viewport"
            name="viewport"
            content="minimal-ui,width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover"
          />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <link rel="apple-touch-icon" href="/dibaex.png" />
          <link rel="apple-touch-startup-image" href="/dibaex.png" />
          <script dangerouslySetInnerHTML={{__html:`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '768118024847391');
        fbq('track', 'PageView');
        `}}></script>
        <noscript><img height="1" width="1" style={{display:"none"}} src="https://www.facebook.com/tr?id=768118024847391&ev=PageView&noscript=1"/></noscript>
        </Head>
        <Script
          strategy="beforeInteractive"
          src={domain + "/beforeInteractive.js?v=1.0.0"}
        />
        <Script src={domain + "/iconpark.js?v=" + Package.version} />
        <Script
          strategy="beforeInteractive"
          src={domain + "/sensorsdata.min.js"}
        />
        <Script
          id={"ze-snippet"}
          src={domain + "/snippet.js?key=abeca4cf-fe11-4e43-a114-ff64f977f9b2"}
          onLoad={() => {
            if (window.zE) {
              zE(
                "messenger:set",
                "locale",
                (() => {
                  const obj = {
                    en: "en-US",
                    ja: "ja",
                    hi: "hi",
                    in: "id",
                    ru: "ru",
                    es: "es-es",
                    tr: "tr",
                    hk: "zh-tw",
                    cn: "zh-cn",
                    vi: "vi",
                    th: "th",
                  };
                  return obj[localeObj.key] || "en-US";
                })()
              );
            }
          }}
        />
        <Script
          id={"sensorsScript"}
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
      var sensors = window['sensorsDataAnalytic201505'];
      sensors.init({
        server_url: '${process.env.NEXT_PUBLIC_sensorsSeverUrl}',
        is_track_single_page: true,
        use_client_time:false,
        send_type:'beacon',
        heatmap: {
          clickmap:'default',
          scroll_notice_map:'default'
        }
      });
  `,
          }}
        />
        <AppProvider payload={payload}>
          <Content>
            <Component {...pageProps} />
          </Content>
        </AppProvider>
      </ConfigProvider>
    </IntlProvider>
  );
}

export default MyApp;

function generateNonceStr(length, type) {
  let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  type === "num" && (chars = "0123456789");
  const maxPos = chars.length;
  let noceStr = "";
  for (let i = 0; i < (length || 32); i++) {
    noceStr += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return noceStr;
}

/*
MyApp.getInitialProps = (context) => {
  let COOKIES = {};
  try {
    COOKIES = context.ctx.req.cookies;
  } catch (e) {}

  return {
    COOKIES,
  };
};
 */
